import React, {useState} from "react"
import * as prosConnect from "../prodect/ProsConnect";
import * as projectLoader from "../prodect/ProjectLoader";
import LoadingAnimation from "../components/LoadingAnimation";
import Spacer from "../components/Spacer";
import {CancelButton, ConfirmButton} from "../components/BasicButton";

// Used when 1st time logged
export function AcceptTerms(props) {
    return <div className={"midi-page"}>
            <header>
                <img className={"flex-center lander-logo"} src={"./images/prodect-text.svg"} alt={"logo"} />
                <h1>Hyväksy käyttäjäehdot jatkaaksesi sovelluksen käyttöä</h1>
            </header>
            <section>
                <TermItems />
            </section>
            <footer>
                <div className="btn-set_center">
                    <CancelButton
                        action={()=> props.termsAccepted(false)}
                    />
                    <ConfirmButton
                        label={"Hyväksy"}
                        action={()=> props.termsAccepted(true)}
                    />
                </div>
            </footer>
    </div>
}

// Used any time later (from settings)
export function TermItems(props) {
    const [terms, setTerms] = useState([])
    async function loadTermsProject() {
        prosConnect.deactivateActiveProject()
        await projectLoader.awaitLoadProjectObjects('TERMS', 'AcceptTerms', true, true)
        let activeProject = prosConnect.getActiveProject()
        if (activeProject) {
            setTerms(prosConnect.getActiveProject()
                .getUiList(undefined, "", false))
        }
    }
    React.useEffect(() => {
        loadTermsProject()
        // Specify how to clean up after this effect:
        return function cleanup() {
            prosConnect.deactivateActiveProject()
        };
    }, [props]);

    if(terms.length < 1){
        return <>
            <Spacer size={"xl"}/>
            <LoadingAnimation size={"lg"}/>
            <Spacer size={"xl"}/>
        </>
    }

    return (terms.map((e, i) => {
        return (e.obsList.map((e,i) => {
            if (e.obj_type === "itm_title") {
                return <h2 key={i}>{e.text}</h2>
            }
            return <p key={i}>{e.text}</p>
        } ))
    }))
}
